import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TypeEatBarService {
  colors = [
    'bg-gradient-to-r from-orange-400 to-orange-600',
    'bg-gradient-to-r from-amber-400 to-amber-600',
    'bg-gradient-to-r from-green-400 to-green-600',
    'bg-gradient-to-r from-yellow-400 to-yellow-600',
    'bg-gradient-to-r from-gray-400 to-gray-600',
  ]
}
